// extracted by mini-css-extract-plugin
export default {"parentView":"style_parentView__eAFNm","item":"style_item__cV3DO"};